var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "trellis-assets": "static-1.3160"
    },
    "depPathPrefixes": {
      "trellis-assets": "/trellis-assets/static-1.3160"
    },
    "bundlingPackage": "academy-achievements-public-ui",
    "bundlingPackageVersion": "static-1.1116",
    "project": "trellis-assets",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};